<template>
    <div>
        <breadCrumb 
            :icon="'fa-user-friends'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_social`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="submitSocialMedia">
                            <div class="row">
                                <div class="col-lg-6 col-xl-6 p-5 border-right">
                                    <div v-for="socialMedia in socialMedias.slice(0, 4)" :key="socialMedia.id" :id="'socialMedia_' + socialMedia.id" class="form-group">
                                        <label class="form-label">{{socialMedia.label}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0" :class="{'img-input-group': socialMedia.id == 'fave'}">
                                                    <img v-if="socialMedia.id == 'fave'" class="img-fluid img-social" :src="require('@/assets/image/icon/fave.png')"/>
                                                    <i v-else :class="socialMedia.icon"></i>
                                                </span>
                                            </div>
                                            
                                            <input type="text" class="form-control bg-transparent pl-3" v-model="socialMedia.value" :placeholder="socialMedia.label">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-6 p-5">
                                    <div class="form-group" v-for="socialMedia in socialMedias.slice(4, 8)" :key="socialMedia.id">
                                        <label class="form-label">{{socialMedia.label}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i :class="socialMedia.icon"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" v-model="socialMedia.value" :placeholder="socialMedia.label">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-left ml-3 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../Bread_Crumb'
import input from './../../../assets/js/dashboard/input'
import {handleSessionExpired} from './../../../assets/js/dashboard/dashboard'

export default {
    name: 'socialMedia',
    components:{
        BreadCrumb
    },
    data(){
        return{
           outlet: [], selectedOutlet: 0,
           socialMedias: input.socialMedias,
        }
    },
    watch:{
        "$i18n.locale"(val){
            for(var i = 0; i < this.socialMedias.length; i++){
                var id = this.socialMedias[i].id;
                this.socialMedias[i].label = this.$i18n.messages[this.$i18n.locale].outlet_setting.social_media[id]
            }
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getSocialMedia();
            }
            this.$parent.isModalShow = false;
        },
       filterByOutlet(item){
            this.selectedOutlet = item;
            this.getSocialMedia();
        },
        getSocialMedia(){
            let $vm = this;
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.SOCIAL_MEDIA;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var results = response.data;

                for (var r in results){
                    for(var i = 0; i < $vm.socialMedias.length; i++){
                        var id = $vm.socialMedias[i].id;
                        if(r == id){
                            $vm.socialMedias[i].label = $vm.$i18n.messages[$vm.$i18n.locale].outlet_setting.social_media[id]
                            $vm.socialMedias[i].value = results[r];
                        }
                    }
                }                
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        submitSocialMedia(){
            let $vm = this
            var data = {};
            for(var i=0; i<this.socialMedias.length; i++){
                data[this.socialMedias[i].id] = this.socialMedias[i].value
            }

            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.SOCIAL_MEDIA;
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){

                    var message = $vm.$i18n.t(`subMenu.salon_setting_social`) + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
    },mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getSocialMedia()  
    }
}
</script>

<style scoped>
.img-input-group{
    padding: 0.5rem 0.65rem;
}
.img-social{
    width: 1.5em;
}
</style>